<ion-content class="build-update-content" [scrollY]="false">
  <div class="update-modal-container">
    <!-- Hero Icon Badge -->
    <div class="update-hero-icon" [attr.data-mode]="mode">
      <span class="material-symbols-outlined icon">{{ heroIcon }}</span>
    </div>

    <!-- Title & Subtitle -->
    <h2 class="update-title">{{ displayTitle }}</h2>
    <p class="update-message">{{ displayMessage }}</p>

    <!-- Version Details Badge (Only for updates) -->
    <div *ngIf="!isMaintenance" class="version-badge-container">
      <div class="version-chip current">
        <span class="version-label">Current</span>
        <span class="version-num">v{{ currentVersion }}</span>
      </div>
      <span class="material-symbols-outlined arrow">arrow_forward</span>
      <div class="version-chip target">
        <span class="version-label">Latest</span>
        <span class="version-num">v{{ targetVersion }}</span>
      </div>
    </div>

    <!-- Maintenance Status Indicator -->
    <div *ngIf="isMaintenance" class="maintenance-status-container">
      <div class="pulsing-dot"></div>
      <span class="maintenance-live-text">Engineers at work • Live Updates</span>
    </div>

    <!-- Action Buttons -->
    <div class="update-actions">
      <!-- Maintenance Retry Button -->
      <app-button
        *ngIf="isMaintenance"
        fill="solid"
        color="primary"
        (handleClick)="actionRetry()"
      >Retry Connection</app-button>

      <!-- Update Primary CTA -->
      <app-button
        *ngIf="!isMaintenance"
        fill="solid"
        color="primary"
        (handleClick)="actionUpdate()"
      >Update Now</app-button>

      <!-- Optional Update "Later" Button -->
      <app-button
        *ngIf="isOptional"
        fill="clear"
        color="medium"
        (handleClick)="actionLater()"
      >Remind Me Later</app-button>
    </div>
  </div>
</ion-content>
